// Imports
const CONFIG = require('../config/constants/panel');

/* *********************************************************************
 *                      JQuery panel component                         *
 **********************************************************************/

/**
 * Create new JQuery functions using the jquery extend property.
 * @param {string} id - panel id
 * @returns {JQuery<Function>} new prototype JQuery function library
 */
$.panel = function (id) {
    return new (function () {
        // Specific panel open/close custom events
        const TRIGGER = {
            OPEN: `${CONFIG.EVENTS.OPEN}:${id}`,
            CLOSE: `${CONFIG.EVENTS.CLOSE}:${id}`
        };

        /**
         * Get panel id.
         * @returns {string} panel id
         */
        this.getID = function () {
            return id;
        };

        /**
         * Show a success alert message.
         */
        this.open = function () {
            $('body').trigger(CONFIG.EVENTS.OPEN, id);
            $('body').trigger(TRIGGER.OPEN);
        };

        /**
         * Show a error alert message.
         */
        this.close = function () {
            $('body').trigger(CONFIG.EVENTS.CLOSE, id);
            $('body').trigger(TRIGGER.CLOSE);
        };

        /**
         * Show a success alert message.
         * @param {string} callback - callback function to execute on panel open
         */
        this.onOpen = function (callback) {
            $('body').on(TRIGGER.OPEN, callback);
        };

        /**
         * Show a error alert message.
         * @param {string} callback - callback function to execute on panel open
         */
        this.onClose = function (callback) {
            $('body').on(TRIGGER.CLOSE, callback);
        };
    })();
};

/* *********************************************************************
 *                JQuery panel custom event listeners                  *
 **********************************************************************/

/**
 * Collection of panel related action functions.
 */
const action = {
    /**
     * Open a panel using a HTML selector.
     * @param {string} selector - panel to open
     */
    open: function (selector) {
        $(selector).addClass(CONFIG.CLASS.OPENED);
        $('body').css('overflow', 'hidden');
    },
    /**
     * Close an element's closest panel.
     * @param {string} selector - selector of the panel to close
     */
    close: function (selector) {
        $(selector).removeClass(CONFIG.CLASS.OPENED);
        $('body').css('overflow', 'auto');
    }
};

/**
 * Collection of panel related event listeners.
 */
const setClickListener = {
    /**
     * Opens a panel, using the data-panel-target attribute of the clicked element.
     */
    open: function () {
        $('body').on('click', `.${CONFIG.CLASS.OPEN}`, function () {
            const panelID = $(this).attr(CONFIG.ATTRIBUTES.DATA_TARGET);
            const panel = $.panel(panelID);

            panel.open();
        });
    },
    /**
     * Closes the closest panel, considering the clicked element.
     */
    close: function () {
        $('body').on('click', `.${CONFIG.CLASS.CLOSE}`, function () {
            const $panel = $(this).closest(`.${CONFIG.CLASS.PANEL}`);
            const panelID = $panel.attr('id');
            const panel = $.panel(panelID);

            panel.close();
        });
    }
};

/**
 * Collection of panel related custom events.
 */
const setActionListeners = {
    /**
     * Event which will open the panel with the provided ID.
     * Example: $('body').trigger('hompanel:open', 'hom-panel-login')
     */
    open: function () {
        $('body').on(CONFIG.EVENTS.OPEN, function (e, panelID) {
            if (panelID && typeof panelID === 'string') {
                action.open(`#${panelID}`);
            }
        });
    },

    /**
     * Event which will close the panel with the provided ID.
     * Example: $('body').trigger('hompanel:close', 'hom-panel-login')
     */
    close: function () {
        $('body').on(CONFIG.EVENTS.CLOSE, function (e, panelID) {
            if (panelID && typeof panelID === 'string') {
                action.close(`#${panelID}`);
            }
        });
    }
};

module.exports = {
    setClickListener: function () {
        setClickListener.open();
        setClickListener.close();
    },
    setActionListeners: function () {
        setActionListeners.open();
        setActionListeners.close();
    }
};
